import { ReturnAppSettings } from "@redotech/redo-customer-portal-shared/settings";
import {
  ExternalShipmentTracker,
  TrackableFulfillment,
} from "@redotech/redo-model/trackable";
import { Flex } from "@redotech/redo-web/flex";
import { ExternalLink } from "@redotech/redo-web/link";
import { replaceWordsByMerchantRequest } from "@redotech/redo-web/settings-elements/order/order-details";
import { Text } from "@redotech/redo-web/text";
import * as classNames from "classnames";
import { memo } from "react";
import * as trackingCss from "../order-tracking.module.css";
import * as fulfillmentCss from "./fulfillment.module.css";

export const TrackingCarrierInfo = memo(function TrackingCarrierInfo({
  fulfillment,
  robustTracker,
  settings,
}: {
  fulfillment?: TrackableFulfillment;
  robustTracker: ExternalShipmentTracker;
  settings: ReturnAppSettings;
}) {
  return (
    <Flex>
      {fulfillment?.tracking_url &&
        settings.storeUrl !== "shopconzuri.myshopify.com" && (
          <Flex dir="column" flex={1} gap="xs">
            <Text className={fulfillmentCss.trackingTitle} fontSize="xl">
              Tracking
            </Text>
            {robustTracker ? (
              <ExternalLink
                className={classNames(trackingCss.tinyText)}
                url={
                  fulfillment?.tracking_url &&
                  !(fulfillment.tracking_url as string).includes("redo")
                    ? fulfillment.tracking_url
                    : robustTracker.public_url
                }
              >
                <Text fontWeight="semibold" textColor="secondary">
                  {robustTracker.tracking_code}
                </Text>
              </ExternalLink>
            ) : (
              <ExternalLink
                className={classNames(trackingCss.tinyText)}
                url={fulfillment?.tracking_url}
              >
                <Text fontWeight="semibold" textColor="secondary">
                  {/* @ts-expect-error: strict-null-checks */}
                  {fulfillment?.tracking_numbers[0]}
                </Text>
              </ExternalLink>
            )}
          </Flex>
        )}
      {robustTracker?.carrier && (
        <Flex dir="column" flex={1} gap="xs">
          <Text fontSize="xl">Carrier</Text>
          <Text
            className={classNames(trackingCss.tinyText)}
            fontWeight="semibold"
          >
            {replaceWordsByMerchantRequest(
              robustTracker.carrier,
              settings.storeUrl,
            )}
          </Text>
        </Flex>
      )}
    </Flex>
  );
});
